<template>
  <v-container>
<!--    <v-card-title>-->
      <h5>Bewertungsskala</h5>
<!--    </v-card-title>-->
<!--    <v-card-text>-->
      <v-row justify='space-between'>
        <v-col cols='12' class='pa-0'>
          <v-row class='d-none d-md-flex' align='center' justify='center'>
            <v-col v-for='s in criterions' :key='s.id' align='center' cols='2' class='pb-0'>{{ s.description }}</v-col>
          </v-row>
          <v-row class='d-md-none' align='center' justify='center'>
            <v-col v-for='s in criterions' :key='s.id' align='center' cols='2' class='pb-0'>{{ s.value }}</v-col>
          </v-row>
          <v-radio-group :value='assessment.selectedValue' column @change='(val) => $emit("ratingChanged", {value: val, assessment})' class='pt-0 mt-0'>
            <v-row align='center' justify='center'>
              <v-col v-for='s in criterions' :key='s.id' align='center' cols='2' justify='center'>
                <span class='d-none'>{{ s.value }}{{ s.factor }}</span>
                <v-radio :value='s.id' class='justify-center'></v-radio>
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
    <v-row class='mx-2' justify='space-between' v-if='cues && cues.length > 0'>
      <v-expansion-panels hover elevation='1'>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-row no-gutters>
              <v-col cols='12'>
                <div class='primary--text'>{{ $i18n.t('AssessmentPage.cues')}}</div>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                class='cueContainer'
                v-for='(cueArea, index) in scale.cueAreaCount'
                :key='`cueArea_${index}`'
                :style='`width: ${100 / scale.cueAreaCount}%`'>
                <template v-for='cue in cuesForArea(index)'>
                  <p :key='cue.id' class='mb-3 cueLink' :class='styleClass(isSelected(cue))' @click='$emit("ki-cue-toggle", {cueId: cue.id, assessment: assessment})'>
                    <v-icon small class='cueIcon'>{{icon(isSelected(cue))}}</v-icon> {{cue.text}}
                  </p>
                </template>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>

</template>

<script>
// import AssessmentCueSelector from '@/components/AssessmentCueSelector';

export default {
  name: 'InterviewRatingCard',
  components: {
    // AssessmentCueSelector
  },
  props: ['criterions', 'cues', 'scale', 'assessment'],
  computed: {

  },
  methods: {
    isSelected(cue) {
      if (this.assessment) {
        return this.assessment.selectedCuesIds.includes(cue.id)
      }
      return cue.isSelected;
    },
    icon(selected) {
      return selected === true ? 'mdi-check-circle-outline' : 'mdi-circle-outline'
    },
    styleClass(selected) {
      return selected === true ? 'cueLinkSelected' : ''
    },
    cuesForArea(cueArea) {
      return this.behavioralAnchors.filter((c) => c.area === cueArea)
    }
  },
  mounted() {}
}
</script>

<style lang='scss' scoped>
@import '@/ci.scss';
.v-radio{
  display: block!important;
  margin-left: 8px!important;
}
.cueContainer {
  border-right: 1px dashed lightgray;
}
.cueLink:hover{
  color: $primary;
  cursor: pointer;
}
.cueLinkSelected {
  color: $primary
}
.cueLinkSelected:hover {
  color: black;
}
.cueIcon {
  color: inherit;
}
</style>
